//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Atrial_fibrillation',
  data () {
    return {
      form: {
        data1: '0',
        data2: '0',
        data3: '0',
        data4: '0',
        data5: '0',
        data6: '',
        data7: ''
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        {value: '0', name: '<60岁'},
        {value: '1', name: ' 60~64岁'},
        {value: '2', name: '≥65岁'}
      ],
      dataList2: [
        {value: '0', name: '男'},
        {value: '1', name: '女'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            if (key == 'data4' && form[key]) {
              result += 2
            } else {
              result += Number(form[key])
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false
        return ''
      } else {
        self.hasScore = true
        return String(result)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Card/Atrial_fibrillation.vue